/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-04-23 17:56:52
 */
// 用户名部分允许点号（如 jie.hu@...），域名支持连字符与多级后缀
export const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
export const phoneReg =
  /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
export const taxNoReg = /^([0-9]|[a-z]|[A-Z])+$/

/**
 * 发票类型
 */
export const invoiceType = {
  company: '0',
  person: '1'
} as const

export type InvoiceTypeValue = (typeof invoiceType)[keyof typeof invoiceType]

/**
 * 发票状态
 */
const invoiceStatus = {
  fail: 1, //开票失败
  success: 2, // 开票成功
  processing: 3 // 开票中
}

export { invoiceStatus }
